"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = void 0;
var constants_1 = require("../../../constants");
exports.ROUTE = constants_1.routes.CANDLE;
//# sourceMappingURL=params.js.map